<template>
  <div>
    <div v-if="candidateCampaigns.length">
      <Pagination
        :total="getCandidateCampaigns?.total_campaign_count || 0"
        :perPage="10"
        :showPageNumber="false"
        @pagechanged="pageChanged"
      />
      <div
        v-for="(campaign, index) in candidateCampaigns"
        :key="index"
        class="card mb-3 shadow-sm cursor-pointer"
      >
        <div class="card-body">
          <div class="row align-items-center text-center text-md-start">
            <div class="col-12 col-md-2 mb-3 mb-md-0">
              <img
                v-if="campaign?.logo_location"
                :src="getFileURL(campaign.logo_location)"
                @error="$event.target.src = '/img/tflogo.png'"
                alt="Campaign Logo"
                class="img-fluid rounded-circle border mx-auto d-block"
                style="width: 80px; height: 80px; object-fit: cover"
              />
              <img
                v-else
                class="rounded-circle border bg-light d-flex align-items-center justify-content-center mx-auto"
                style="width: 80px; height: 80px"
                src="/img/tflogo.png"
              />
            </div>

            <div class="col-12 col-md-7 text-left">
              <h5 class="mb-1 fw-semibold">
                {{ campaign.campaign_name }}
              </h5>
              <p class="mb-0 text-muted text-truncate">
                {{ campaign.welcome_text || "" }}
              </p>
            </div>

            <div
              class="col-12 col-md-3 mt-3 mt-md-0 d-flex flex-column flex-md-row align-items-center align-items-md-end justify-content-center justify-content-md-end gap-3"
            >
              <div class="text-center text-md-end">
                <CBadge
                  shape="pill"
                  class="px-3 py-2 fs-6"
                  :color="campaign?.response_submitted ? 'success' : 'primary'"
                  @click="$router.push(`campaign/${campaign.campaign_uuid}`)"
                >
                  {{ campaign?.response_submitted ? "Completed" : "Incomplete" }}
                </CBadge>

                <div v-if="campaign.answered_on" class="text-muted small mt-2">
                  <span>
                    {{ campaign?.response_submitted ? "Responded at" : "Visited on" }}
                    {{ formatDate(campaign.answered_on) }}
                  </span>
                </div>
              </div>

              <div class="m-2 text-center">
                <SocialShareButton
                  :title="campaign?.campaign_name"
                  :description="campaign?.description"
                  :url="campaign?.campaignURL"
                  :platforms="['facebook', 'linkedin', 'x', 'whatsapp', 'email']"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="text-center py-5 text-muted">
      <div class="h5">No campaigns found</div>
    </div>
  </div>
</template>

<script>
import m from "moment";
import { mapActions, mapGetters } from "vuex";
import { generateLocalFileUrl } from "@/helpers/helper.js";
import { HOST } from "@/service_urls";
import Pagination from "../../components/reusable/Pagination.vue";
import SocialShareButton from "@/components/reusable/SocialShareButton.vue";

export default {
  name: "CandidateCampaigns",
  components: {
    Pagination,
    SocialShareButton
  },
  data() {
    return {
      generateLocalFileUrl,
    };
  },
  computed: {
    ...mapGetters(["getCandidateCampaigns", "getPathAcronymFromAccessToken"]),
    candidateCampaigns() {
      return (
        this.getCandidateCampaigns?.campaigns?.map((v) => {
          return {
            campaignURL: `${HOST}/${this.getPathAcronymFromAccessToken}/campaign/${v?.campaign_uuid}`,
            ...v
          };
        }) || []
      );
    },
  },
  methods: {
    ...mapActions(["fetchCandidateCampaigns"]),
    getFileURL(path_url) {
      return this.generateLocalFileUrl(`file:///file_store/${path_url}`)
    },
    formatDate(date) {
      return date ? m(date).format("DD MMM YYYY") : "";
    },
    pageChanged(page) {
      const skip = (page - 1) * 10;
      const limit = 10;
      this.fetchCandidateCampaigns({ skip, limit });
    }
  },
  async mounted() {
    await this.fetchCandidateCampaigns();
  },
};
</script>
